import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom'
import { useForm } from '../../hooks/useForm'
import backArrowIcon from '../../assets/img/back-arrow.png';
import "../../assets/css/common.css";
import { useAuth } from '../../routers/AuthProvider';
import axios from 'axios';
import { API_URL } from '../../utils/constant';
import { Toast } from '../../components/ToastComponent';





export default function EditGiftRule() {
    const { id } = useParams();
    const location = useLocation();
    const { initialData } = location.state;
    const backPath = `/loyalty/gift-rule/list`;
    const { handleInputChange, formData, submitForm, setError, error } = useForm();
     useEffect(()=>{
                      if(error){
                         Toast.fire({
                  title: error ,
                  icon: "error",
                });
                      }
                  },[error])
    const navigate = useNavigate();
    const { user, setLoading } = useAuth();
    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true)
        const data = {
            ...formData,
            status: 'ACTIVE',
        }
        submitForm('PUT', '/presentRule/' + id, data, () => {
        //     navigate(backPath)
        // });
         navigate(backPath)
        }, "Successfully Updated");
    }

    const [presents, setPresents] = useState();
    const [errorMessage, setErrorMessage] = useState("");
    const [qty, setQty] = useState();

    const [errorPointMessage, setErrorPointMessage] = useState("");
    const [point, setPoint] = useState();
    useEffect(() => {
        axios.get(API_URL + '/present', {
            withCredentials: true
        })
            .then(response => {
                setPresents(response.data.data)
            })
    }, []);

    return (
        <div className='sub-page-layout-1'>
            <Link className='back-to-page' to={backPath}>
                <img src={backArrowIcon} />
                Back
            </Link>
            <div className='container' style={{ height: 'auto' }}>
                <h1 className='sub-page-title'>Edit Gift Rule</h1>
                <div className='form-container'>
                    <form onSubmit={onSubmit} className='form flex flex-col justify-between w-full'>
                        <h2 className='sub-title mb-8'>Gift Rule Information</h2>
                        <div className='grid grid-cols-2 gap-9'>
                            <div className='grow'>
                                <label className='x-label input-required'>Gift Rule Name</label>
                                <input type='text'
                                    required
                                    name='present_rule_name'
                                    defaultValue={initialData.present_rule_name}
                                    onChange={handleInputChange}
                                    className='x-input' />
                            </div>
                            <div className='grow'>
                                <label className='x-label input-required'>Gift Name</label>
                                <div className='dd-container'>
                                    <select
                                        type='text'
                                        name='present_id'
                                        required
                                        onChange={handleInputChange}
                                        value={formData.present_id ? formData.present_id : initialData.present_id}
                                        className='x-input dropdown'
                                    >
                                        {presents && presents.map((item, index) => (
                                            <option key={index} value={item.present_id}>{item.present_name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className='grow'>
                                <label className='x-label input-required'>Quantity</label>
                                <input type='text'
                                inputMode='numeric'
                                    required
                                    defaultValue={initialData.qty}
                                    name='qty'
                                    autoComplete='false'
                                    //onChange={handleInputChange}
                                    pattern="[0-9]{1,}"
                                    onChange={e => {
                                        const numericValue = e.target.value.replace(/[^0-9]/g, "");
                                        setQty(numericValue);

                                        const numeric = parseInt(numericValue, 10);

                                        if (!numericValue) {
                                            setErrorMessage("Please enter a number.");
                                        } else if (isNaN(numeric) || numeric < 1) {
                                            setErrorMessage("Number must be 1 or greater.");
                                        } else {
                                            setErrorMessage(""); // Clear message when valid
                                        }
                                        handleInputChange({ target: { name: 'qty', value: numericValue } });
                                    }}

                                    onKeyDown={e => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                        }
                                    }}
                                    className='x-input' />
                                    {errorMessage && (
                                    <div className="text-red-500 text-sm mt-1">{errorMessage}</div>
                                )}
                            </div>
                            <div className='grow'>
                                <label className='x-label input-required'>Minimum Point</label>
                                <input type='text'
                                inputMode='numeric'
                                    required
                                    defaultValue={initialData.minimum_point}
                                    name='minimum_point'
                                    autoComplete='false'
                                    //onChange={handleInputChange}
                                    pattern="[0-9]{1,}"
                                    onChange={e => {
                                        const numericValue = e.target.value.replace(/[^0-9]/g, "");
                                        setPoint(numericValue);

                                        const numeric = parseInt(numericValue, 10);

                                        if (!numericValue) {
                                            setErrorPointMessage("Please enter a number.");
                                        } else if (isNaN(numeric) || numeric < 1) {
                                            setErrorPointMessage("Number must be 1 or greater.");
                                        } else {
                                            setErrorPointMessage(""); // Clear message when valid
                                        }
                                        handleInputChange({ target: { name: 'minimum_point', value: numericValue } });
                                    }}

                                    onKeyDown={e => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                        }
                                    }}
                                    className='x-input' />
                                    {errorPointMessage && (
                                    <div className="text-red-500 text-sm mt-1">{errorPointMessage}</div>
                                )}
                            </div>
                        </div>
                        <div className='form-btn-group'>
                           
                            <div className='flex justify-end gap-5 mt-5'>
                                <Link to={backPath} className='white-btn'>Cancel</Link>
                                <button className='gold-btn'>Save</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}